import React from 'react';
import { useData } from '../context/DataContext';
import SEO from '../components/SEO';

const About = () => {
  const { bio } = useData();
  // Schema for Person (Artist)
  const personSchema = {
    "@context": "https://schema.org",
    "@type": "Person",
    "name": bio.name,
    "jobTitle": bio.role,
    "description": bio.description[0],
    "email": bio.email,
    "url": "https://leon-krykhtin.com",
    "sameAs": bio.socials ? bio.socials.map(s => s.url) : []
  };

  return (
    <div className="max-w-2xl animate-in fade-in duration-700 pb-20">
      <SEO 
        title="About" 
        description={`Biography and portfolio of ${bio.name}, ${bio.role}.`}
        url="/about"
        schema={personSchema}
      />
      <div className="mb-12">
        <img 
          src="https://customer-assets.emergentagent.com/job_krykhtin-showcase/artifacts/l3lkiwpr_IMG_9359.jpeg"
          alt="Leon Krykhtin" 
          className="w-full aspect-[16/9] object-cover grayscale mb-8 shadow-sm"
        />
        <h2 className="text-3xl font-bold tracking-tighter uppercase mb-2">{bio.name}</h2>
        <p className="text-neutral-500 mb-8">{bio.role}</p>
      </div>

      <div className="space-y-6 text-lg leading-relaxed text-neutral-800">
        {bio.description.map((paragraph, idx) => (
          <p key={idx}>{paragraph}</p>
        ))}
      </div>

      <div className="mt-16 pt-8 border-t border-neutral-200">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div>
                <h3 className="text-sm font-bold uppercase tracking-widest mb-4">Socials</h3>
                <ul className="space-y-2">
                    {bio.socials && bio.socials.map((social, idx) => (
                        <li key={idx}>
                            <a 
                                href={social.url} 
                                target="_blank" 
                                rel="noopener noreferrer"
                                className="text-lg hover:text-neutral-500 transition-colors flex items-center"
                            >
                                <span className="font-medium mr-2">{social.label}:</span>
                                <span className="text-neutral-600">{social.value}</span>
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
            <div>
                <h3 className="text-sm font-bold uppercase tracking-widest mb-4">Contact</h3>
                <a 
                  href={`mailto:${bio.email}`}
                  className="text-lg hover:text-neutral-500 transition-colors block"
                >
                  {bio.email}
                </a>
            </div>
        </div>
      </div>
    </div>
  );
};

export default About;
